import Palette from './palette'
import Chart from './chart'

export default {
  Palette,
  Chart
}



// WEBPACK FOOTER //
// ./src/theme/colors/index.js